import PageHero from "../components/sections/PageHero";
import ServiceCard from "../components/ui/ServiceCard";
import { services } from "../data/services";
import GoldButton from "../components/ui/GoldButton";
import ScrollReveal from "../components/motion/ScrollReveal";
import StaggerContainer from "../components/motion/StaggerContainer";
import MagneticButton from "../components/motion/MagneticButton";
import WaveDivider from "../components/graphics/WaveDivider";

const numerals = ["I", "II", "III"];

const Services = () => (
  <>
    <PageHero
      label="SERVICES"
      title="What we build."
      titleAccent="What we deliver."
      subtitle="Three pillars of capability — each backed by engineering depth, not surface-level deliverables."
    />

    <section style={{ background: "#050505", padding: "0 0 100px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <StaggerContainer
          stagger={0.15}
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          {Object.values(services).map((svc, i) => (
            <div key={svc.title} style={{ flex: "1 1 300px" }}>
              <ServiceCard title={svc.title} items={svc.items} slug={svc.slug} numeral={numerals[i]} />
            </div>
          ))}
        </StaggerContainer>

        <WaveDivider variant="fracture" style={{ margin: "60px 0" }} />

        <ScrollReveal direction="up" delay={0.1}>
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, fontSize: "clamp(28px, 3.5vw, 44px)", color: "#F8F4EC", marginBottom: 16 }}>
              Need something <span style={{ color: "#D4A843", fontWeight: 700 }}>custom?</span>
            </h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 16, color: "#8B8378", marginBottom: 32, fontWeight: 300, maxWidth: 480, margin: "0 auto 32px" }}>
              We build solutions that don't fit into categories. Let's talk about your specific needs.
            </p>
            <MagneticButton>
              <GoldButton href="/contact">DISCUSS YOUR PROJECT</GoldButton>
            </MagneticButton>
          </div>
        </ScrollReveal>
      </div>
    </section>
  </>
);

export default Services;
